let getGeolocationPromise: Promise<GeolocationPosition> | null = null;

export function computeMyLocation() {
	if (getGeolocationPromise) {
		return getGeolocationPromise;
	}
	getGeolocationPromise = new Promise<GeolocationPosition>((resolve, reject) => {
		navigator.geolocation.getCurrentPosition(
			(position) => {
				resolve(position);
			},
			(error) => {
				reject(error);
			},
		);
	});

	return getGeolocationPromise;
}

export async function getMyLocation() {
	if (getGeolocationPromise === null) {
		return computeMyLocation();
	}
	return getGeolocationPromise;
}

export function resetMyLocation() {
	getGeolocationPromise = null;
}

export async function isGeolocationGranted() {
	const permission = await navigator.permissions.query({ name: 'geolocation' });
	return permission.state === 'granted';
}
